var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as moment from "moment";
export var MandateListMapper = function (data, filterRequired) {
    var _a, _b, _c, _d;
    var result = {};
    var filteredResult = [];
    if ((data === null || data === void 0 ? void 0 : data.data) && ((_b = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.mandateList) === null || _b === void 0 ? void 0 : _b.length) > 0) {
        filteredResult = (_d = (_c = data === null || data === void 0 ? void 0 : data.data) === null || _c === void 0 ? void 0 : _c.mandateList) === null || _d === void 0 ? void 0 : _d.filter(function (entry) { return FilterMandate(entry) === true; });
    }
    if (filterRequired && (filteredResult === null || filteredResult === void 0 ? void 0 : filteredResult.length) > 0) {
        filteredResult = filteredResult === null || filteredResult === void 0 ? void 0 : filteredResult.filter(function (entry) {
            return entry.dpStatus.toLowerCase() === "active" ||
                entry.dpStatus.toLowerCase() === "registration pending" ||
                entry.dpStatus.toLowerCase() === "verification in progress" ||
                entry.dpStatus.toLowerCase() === "document not uploaded" ||
                entry.dpStatus.toLowerCase() === "processing";
        });
    }
    filteredResult = filteredResult === null || filteredResult === void 0 ? void 0 : filteredResult.map(function (mandateData) {
        return __assign(__assign({}, mandateData), { status: mandateData.dpStatus }); // overwrite the status with dpstatus
    });
    result = {
        data: {
            type: "",
            lst: filteredResult,
        },
    };
    return result;
};
export var FilterMandate = function (mandate) {
    var _a;
    if ((mandate === null || mandate === void 0 ? void 0 : mandate.mandateStatus) === "Approved")
        return true;
    // let dateDiff = moment(mandate?.createdOn)?.diff(moment(), "days");
    var dateDiff2 = (_a = moment()) === null || _a === void 0 ? void 0 : _a.diff(moment(mandate === null || mandate === void 0 ? void 0 : mandate.createdOn), "days");
    if (dateDiff2 < 31)
        return true;
    else
        return false;
};
